
<component
  :is="as"
  class="card-note"
  v-bind="$attrs"
  v-on="$listeners"
>
  <card-image :image-url="imageUrl" />
  <div v-html="cardNote.text" />
</component>
